@if (control) {
  <mat-form-field
    appearance="outline"
    class="ui-select-field ui-form-field-v2"
    [class.ui-select-compact]="isCompact"
    [subscriptSizing]="isCompact || description ? 'dynamic' : 'fixed'"
  >
    @if (!isCompact) {
      <mat-label>{{ label }}</mat-label>
    }
    <mat-select
      [panelClass]="'app-ui-select' + ' ' + panelClass"
      [attr.aria-label]="isCompact ? label : null"
      [formControl]="control"
      [multiple]="isMultiple"
      [placeholder]="emptyTriggerLabel ? (emptyTriggerLabel | translate) : placeholder"
      [hideSingleSelectionIndicator]="false"
      (selectionChange)="onChange($event)"
      [value]="selected"
      [required]="required"
      [errorStateMatcher]="errorStateMatcher"
      [compareWith]="compareWith"
      (openedChange)="onPanelOpenedChange($event)"
    >
      <mat-select-trigger>
        @if (!isMultiple && control.value !== null && control.value !== undefined) {
          <span class="ui-select-trigger-content">
            @if (isCompact && triggerPrefix) {
              <span class="ui-select-trigger-prefix">{{ triggerPrefix | translate }}:</span>
            }
            <span class="ui-select-trigger-label">
              {{ triggerLabel || getSelectedOptionName(control.value) | translate }}
            </span>
            @if (isSelectedOptionPaused(control.value)) {
              <app-department-paused-badge
                class="ui-select-trigger-paused-badge"
                [iconOnly]="true"
              ></app-department-paused-badge>
            }
          </span>
        }
        @if (
          isMultiple &&
          control.value !== null &&
          control.value !== undefined &&
          control.value.length > 0
        ) {
          <span>
            @for (selectedOptionName of selectedOptionNameKeys; track $index; let last = $last) {
              {{ selectedOptionName | translate }}{{ last ? '' : ', ' }}
            }
          </span>
        }
        @if (isMultiple && (!control.value || control.value.length === 0) && emptyTriggerLabel) {
          <span class="ui-select-empty-trigger">{{ emptyTriggerLabel | translate }}</span>
        }
      </mat-select-trigger>
      @if (enableSearch) {
        <input
          #searchInput
          (keyup)="$event.stopPropagation(); onSearch($event)"
          (keydown)="$event.stopPropagation()"
          (keydown.space)="$event.preventDefault(); $event.stopPropagation()"
          placeholder="{{ 'search' | translate }}"
          class="mat-dropdown-select-input"
        />
        @if (searchMode === 'api' && showSearchApiHint) {
          <div class="search-api-hint">{{ 'searchToRevealOrScrollDescription' | translate }}</div>
        }
      }
      @if (enableBlankOption && !isMultiple) {
        <mat-option></mat-option>
      }
      @if (selectAll) {
        <mat-optgroup class="select-all-checkbox-row-group divider-bottom">
          <mat-checkbox
            class="mat-option select-all-row"
            color="primary"
            [ngClass]="{ 'mat-selected': areSomeRowsSelected || areAllRowsSelected }"
            [indeterminate]="areSomeRowsSelected"
            [checked]="areAllRowsSelected"
            (click)="$event.stopPropagation()"
            (change)="toggleSelection($event)"
          >
            {{ 'selectAll' | translate }}
          </mat-checkbox>
        </mat-optgroup>
      }
      @if (selectAllSingleChoice) {
        <mat-option
          class="mat-option select-all-row-single-choice"
          [value]="{ id: SELECT_ALL_VALUE }"
        >
          {{ 'all' | translate }}
        </mat-option>
      }
      @if (returnWholeObject) {
        @for (option of getDisplayedOptionsForRender(); track option.id + '-' + $index) {
          <mat-option
            [value]="option"
            [ngClass]="option.optionClass"
            [disabled]="option.isOptionDisabled"
          >
            <ng-container
              *ngTemplateOutlet="optionTemplate; context: { option: option }"
            ></ng-container>
          </mat-option>
        }
      } @else {
        @if (returnData) {
          <ng-container *ngTemplateOutlet="valueData"></ng-container>
        } @else {
          @for (option of getDisplayedOptionsForRender(); track option.id + '-' + $index) {
            <mat-option
              [value]="option.id"
              [ngClass]="option.optionClass"
              [disabled]="option.isOptionDisabled"
              (click)="optionClick.emit(option.id)"
            >
              <ng-container
                *ngTemplateOutlet="optionTemplate; context: { option: option }"
              ></ng-container>
            </mat-option>
          }
        }
      }
      <ng-template #optionTemplate let-option="option">
        <div
          class="ui-select-option-row"
          [style.marginLeft.px]="option.indent * indent"
          [ngClass]="{ 'top-level-indent': !option.indent && hasIndent }"
        >
          <span class="ui-select-option-label">
            @if (option.isFavorite) {
              <span class="favorite-option">
                <mat-icon class="favorite-icon">star</mat-icon>
                {{ option.name | translate }}
              </span>
            } @else {
              <span>{{ option.name | translate }}</span>
            }
            @if (option.optionSuffix) {
              ({{ option.optionSuffix | translate }})
            }
            @if (option.icon) {
              <mat-icon class="ui-select-option-icon">{{ option.icon }}</mat-icon>
            }
          </span>
          @if (option.isPaused) {
            <app-department-paused-badge
              class="ui-select-paused-badge"
              [iconOnly]="true"
            ></app-department-paused-badge>
          }
        </div>
      </ng-template>
      <ng-template #valueData>
        @for (option of getDisplayedOptionsForRender(); track $index) {
          <mat-option
            [value]="option.data"
            [ngClass]="option.optionClass"
            [disabled]="option.isOptionDisabled"
          >
            <ng-container
              *ngTemplateOutlet="optionTemplate; context: { option: option }"
            ></ng-container>
          </mat-option>
        }
      </ng-template>
      @if (!getDisplayedOptionsForRender()?.length) {
        <mat-option disabled>
          {{ 'currentlyNoDataAvailable' | translate }}
        </mat-option>
      }
    </mat-select>
    @if (!isCompact && description) {
      <mat-hint>{{ description }}</mat-hint>
    }
    @let errorText = control.errors | joinErrorMessages: messages;
    @if (!isCompact) {
      <mat-error [attr.title]="errorText">{{ errorText }}</mat-error>
    }
  </mat-form-field>
}
